import { get, writable } from 'svelte/store';
import { browser } from '$app/environment';

export type TFeatureFlag = 'fakeBankId';

export type TFeatureFlags = Record<TFeatureFlag, boolean>;

const defaults: TFeatureFlags = {
    fakeBankId: false
};

const STORAGE_KEY = 'feature-flags';

const stored = browser ? localStorage.getItem(STORAGE_KEY) : null;
const initial = stored ? JSON.parse(stored) : defaults;

export const store = writable<TFeatureFlags>(initial);

export const read = (flag: TFeatureFlag): boolean | undefined => get(store)[flag];

export const update = (flag: TFeatureFlag, value: boolean) => {
    const updates = { ...get(store), [flag]: value };

    store.set(updates);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updates));
};

export const toggle = (flag: TFeatureFlag) => {
    const current = get(store);

    update(flag, !current[flag]);
};

export const toFeatureFlags = (searchParams: URLSearchParams) => {
    const flags: TFeatureFlags = { ...defaults };
    for (const defaultsKey in defaults) {
        const key = defaultsKey as TFeatureFlag;
        const defaultValue = defaults[key];
        const maybeValue = searchParams.get(key);
        const value = maybeValue ? (maybeValue == 'true' ? true : false) : defaultValue;
        flags[key] = value;
    }
    return flags;
};
